export const RouterName = {
    "所有教学活动模块":"所有教學活動模塊",
    "我的表现":"我的表現",
    "表现":"表現",
    '选择活动类型':"選擇活動類型",
    "星星":"星星",
    "奖励":"獎勵",
    "扣除":"扣除",
    "新建":"新建",
    '奖励星星':"獎勵星星",
    "扣除星星":"扣除星星",
    "新建活动类型":"新建活動類型",
    "请选择星星数":'請選擇星星數',
    "请输入星星数":'請輸入星星數',
    "选择分组批次":"選擇分組批次",
    "排行榜":"排行榜",
    "课程人数":"課程人數",
    "星星统计星":"星星統計(星)",
    "参与人数统计人":"參與人數統計(人)",
    "星星卡活动":"星星卡活動",
    "其他活动":"其他活動",
    "表现统计":"表現統計",
    "总星星":"總星星",
    "第一小组":"第壹小組",
    "参与活动":"參與活動",
    "星":"星",
    "平台活动":"平臺活動",
    "当前排名":"當前排名：",
    "总星星数":"總星星數",
    "此星星卡有效可以使用":"此星星卡有效，可以使用",
    "星星卡":"星星卡",
    "返回首页":"返回首頁",
    "此星星卡无效":"此星星卡無效",
    "已被学生":"已被學生",
    "于":"於",
    "扫描了":"掃描了",
    "请选择活动类型":"請選擇活動類型",
    "查看表现":"查看表現",
    "扫码失败":"掃碼失敗",
    "请选择一个活动类型":"請選擇壹個活動類型",
    "当前排行":"當前排行",
    "参与活动数":"參與活動數",
    "得星记录":"得星記錄",
    "今日表现榜":"今日表現榜",
    "总表现榜":"總表現榜",
    "按姓名排序":"按姓名排序",
    "按得星数排序":"按得星數排序",
    "按学号排序":"按學號排序",
    "继续奖励":"繼續獎勵",
    "批量奖励":"批量獎勵",
    "操作成功":"操作成功",
    "自定义":"自定義",
}